import {isNil} from 'ramda';

import {ExtractDeliveryNoteDocumentResult} from '@prompt-bridge/shared/validations';

import {DeliveryNoteDocumentPreviewFormDefinition} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

/** Only tenant mappings may change before committing an entire structured invoice. */
export function hasStructuredInvoiceChanges(
  values: DeliveryNoteDocumentPreviewFormDefinition,
  document: ExtractDeliveryNoteDocumentResult | null
): boolean {
  if (isNil(document)) {
    return true;
  }

  const sourceItems = document.listOfItems.flatMap((page) => page.items);
  if (
    values.basicInformation.invoiceNumber !== document.basicInformation.invoiceNumber ||
    values.basicInformation.currency !== document.basicInformation.currency ||
    Boolean(values.basicInformation.deliveryNoteNumber) ||
    sourceItems.length === 0 ||
    values.listOfItems.length !== sourceItems.length
  ) {
    return true;
  }

  return sourceItems.some((source) => {
    const item = values.listOfItems.find(
      (candidate) => candidate.sourceLineNumber === source.sourceLineNumber
    );
    return (
      !item ||
      !item.isActive ||
      !source.sourceLineNumber ||
      item.number !== (source.catalogueNumber ?? '') ||
      item.name !== (source.name ?? '') ||
      item.quantity !== source.quantity ||
      item.unitPrice !== source.unitPrice ||
      item.totalPrice !== source.totalPrice
    );
  });
}
